import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Card, Checkbox } from 'antd';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
const MultipleClientForm = (props) => {
    var _a;
    const applicationData = useSelector((state) => state.applicationData);
    useEffect(() => {
        var _a, _b, _c, _d;
        console.log(applicationData);
        (_a = props.form) === null || _a === void 0 ? void 0 : _a.setFieldsValue({
            lstClient: applicationData.selClientList
                ? (_b = applicationData.selClientList) === null || _b === void 0 ? void 0 : _b.map((item) => item.intId)
                : [(_d = (_c = applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.intCompanyID]
        });
    }, []);
    const optMultiClient = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.clientList) === null || _a === void 0 ? void 0 : _a.map((obj) => ({
        label: obj.strLongDesc,
        value: obj.intId
    }));
    return (_jsx(Card, { size: "small", style: { border: '1px solid #43485F', width: 'fit-content' }, children: _jsx(Form.Item, { name: "lstClient", label: "Multiple client", rules: [{ required: true, message: 'Please select an atleast one client!' }], children: _jsx(Checkbox.Group, { options: optMultiClient, style: { display: 'flex', flexDirection: 'column' } }) }) }));
};
export default MultipleClientForm;
